export const STORE_TARGET_SESSION_CONTEXT = 'storeTargetSessionContext'

export const SESSION_CREATE = 'SESSION_CREATE'
export const SESSION_UPDATE = 'SESSION_UPDATE'
export const SESSION_MERGE_IN = 'SESSION_MERGE_IN'
export const SESSION_INVALIDATE = 'SESSION_INVALIDATE'
